<template lang="html">
	<div class="omapi-plugin-header">
		<div id="omwp-plugin-banner" class="omapi-plugin-banner">
			<div class="omapi-plugin-banner__wrapper">
				<div class="omapi-plugin-banner__logo">
					<img src="../../assets/images/logo-om.svg" alt="OptinMonster Logo" />
					<span class="omapi-plugin-banner__page">{{ bannerTitle }}</span>
					<span v-if="betaVersion"
						>&nbsp;&mdash;&nbsp;<strong>Beta Version: {{ betaVersion }}</strong></span
					>
				</div>
				<ul class="omapi-plugin-banner__icons">
					<li>
						<a
							class="omapi-plugin-banner__icon omapi-help help-white"
							target="_blank"
							rel="noopener"
							:href="url"
						></a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script lang="js">
import { mapState, mapGetters } from 'vuex'
import { getAppData } from '@/utils'

export default  {
	computed : {
		...mapGetters([ 'shouldFetchUser', 'connected', 'showProUpsells' ]),
		...mapState([ 'bannerTitle' ]),
		betaVersion () {
			return getAppData('betaVersion')
		},
		url () {
			return this.showProUpsells ? this.$urls.app('redirect/wp-plugin-support/') : this.$urls.docs('', 'BannerHelpButton');
		},
	},
	mounted () {
		this.$store.dispatch('notifications/fetch')
	},
};
</script>
